<div class="accordion-convergence -main">
  <div class="main-title" (click)="changeExpandState()">
    <wp-icon name="chevron-down" size="lg" class="accordion-convergence -icon" [class.-open]="!closed"> </wp-icon>
    <h4 class="accordion-convergence -title">{{ title }}</h4>
    <h5 class="accordion-convergence -date">{{ date }}</h5>
  </div>

  <div class="accordion-convergence -hiddenRow" [@closed]="closed">
    @if (subtitle) {
    <div class="accordion-convergence -subtitle">
      <p>{{ subtitle }}</p>
    </div>
    }
    <div class="-content-description">
      <div class="accordion-convergence -hiddenContent">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
